<template>
  <div class="empty-state">
    <div class="empty-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm0 12H4V6h5.17l2 2H20v10Zm-8-4h2v2h-2v-2Zm0-6h2v4h-2V8Z"/></svg>
    </div>
    <h3 class="empty-title">{{ title }}</h3>
    <p class="empty-desc" v-if="description">{{ description }}</p>
    <button class="btn-primary empty-action" v-if="actionLabel" @click="$emit('action')">
      {{ actionLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: { type: String, default: 'Nenhum item encontrado' },
    description: { type: String, default: '' },
    actionLabel: { type: String, default: '' }
  },
  emits: ['action']
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--spacing-2xl) var(--spacing-base);
  text-align: center;
}
.empty-icon {
  color: var(--color-text-muted);
  opacity: 0.4;
  margin-bottom: var(--spacing-base);
}
.empty-title {
  font-size: var(--text-lg);
  font-weight: 600;
  color: var(--color-text-heading);
  margin-bottom: var(--spacing-sm);
}
.empty-desc {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  max-width: 300px;
  margin-bottom: var(--spacing-base);
}
.empty-action {
  padding: 10px 24px;
}
</style>
